import React, { useState, useEffect } from 'react';
import './CookiePolicyBanner.css';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-animation-bg"></div>
      <div className="cookie-banner-content">
        <h2 className="cookie-title">Use of Cookies</h2>
        <p className="cookie-text">
          We use cookies to enhance your experience and analyze site traffic. 
          By clicking “Accept,” you agree to our use of cookies. See our{' '}
          <a href="/cookiePolicy" target="_blank" rel="noopener noreferrer">
            Cookie Policy
          </a>{' '}
          for more details.
        </p>
        <button className="cookie-accept-btn" onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
